import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCallback } from "react";
import { SubscriptionInvoiceItem as SubscriptionInvoiceItemModel } from "../../../types/generated/models";
import Row from "../../Shared/Row";
import { palette } from "@powerdiary/components-library/lib/theme";

interface ISubscriptionInvoiceItemProps {
    invoice: SubscriptionInvoiceItemModel;
}

export default function SubscriptionInvoiceItem({ invoice }: ISubscriptionInvoiceItemProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const downloadInvoice = useCallback(() => {
        if (!invoice.downloadUrl) {
            return;
        }
        globalThis.location.assign(invoice.downloadUrl);
    }, [invoice.downloadUrl]);

    return (
        <Box
            sx={{
                border: `1px solid ${palette.neutral["300"]}`,
                borderRadius: "4px",
                padding: "24px",
                width: "100%",
                minWidth: 0,
            }}
            data-test-id={`section_subscription_invoice_item_${invoice.invoiceNumber}`}
        >
            <Box sx={{ display: "flex", flexDirection: "row", gap: "8px", marginBottom: "8px" }}>
                <Typography variant="subtitle1" fontWeight="bold" data-test-id="text_invoice_date">
                    {invoice.invoiceDate}
                </Typography>
                <Typography variant="subtitle1" data-test-id="text_invoice_number">
                    {`Invoice #${invoice.invoiceNumber}`}
                </Typography>
            </Box>
            <Box
                sx={{
                    flexDirection: isMobile ? "column" : "row",
                    display: "flex",
                    gap: isMobile ? "24px" : "4px",
                    overflow: "hidden",
                    minWidth: 0,
                }}
            >
                <Box
                    sx={isMobile ? { width: "100%", minWidth: 0, overflow: "hidden" } : { flex: "1 1 0", minWidth: 0 }}
                >
                    <Row subtitle="Type" value={invoice.invoiceType ?? ""} dataTestIdSuffix="invoice_type" />
                    <Row subtitle="Payment Date" value={invoice.paymentDate ?? ""} dataTestIdSuffix="payment_date" />
                </Box>
                <Box
                    sx={isMobile ? { width: "100%", minWidth: 0, overflow: "hidden" } : { flex: "1 1 0", minWidth: 0 }}
                >
                    <Row subtitle="Invoice Total" value={invoice.invoiceTotal ?? ""} dataTestIdSuffix="invoice_total" />
                    <Row subtitle="Paid" value={invoice.amountPaid ?? ""} dataTestIdSuffix="amount_paid" />
                    <Row subtitle="Owing" value={invoice.amountOwing ?? ""} dataTestIdSuffix="amount_owing" />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: isMobile ? "flex-start" : "flex-end",
                        gap: "8px",
                    }}
                >
                    <Button
                        sx={{ width: isMobile ? "100%" : "100px" }}
                        size="extraSmall"
                        variant="outlined"
                        onClick={downloadInvoice}
                        data-test-id="button_download_invoice"
                    >
                        Download
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
